import { createSelector } from 'reselect';

export const yearsSelector = state => state.years;

export const years = createSelector(yearsSelector, years => {
  if (years) {
    return years.map(year => {
      return { data: year, label: year };
    });
  } else {
    return [];
  }
});



// WEBPACK FOOTER //
// ./src/store/reducers/years/selectors.js